import React from 'react';
import Portal from "@Features/portals/components/Portal";
import TravelingDotComIconGlobe from "@Icons/checkOrder/IconGlobe";
import {toggleLoginModal} from "@MyProfile/reducers/userProfileSlice";
import {useTranslation} from "@Translation/hooks/useTranslation";
import useIsMobile from "@Hooks/selector/useIsMobile";
import useIsSmallTablet from "@Hooks/selector/useIsSmallTablet";
import {toggleMobileLogin} from "@Reducers/mobileSlice";
import {useAppDispatch} from "@Hooks/dispatch/useAppDispatch";
import StationLocatorInputForm from "@Pages/stationLocator/components/StationLocatorInputForm";
import CardIconCentered from "@Generic/cards/CardIconCentered";
import IconTicketQr from "@Icons/ticket/IconTicketQr";

function StationLocator() {
    const dispatch = useAppDispatch()
    const isMobile = useIsMobile()
    const isSmallTablet = useIsSmallTablet()
    const locatorCardTitle = useTranslation('station.locator.still_exploring');
    const locatorCardDescription = useTranslation('station.locator.use_our_station_locator');
    const purchasedTicketCardTitle = useTranslation('station.locator.have_ticket');
    const purchasedTicketCardDescription = useTranslation('station.locator.sign_in');

    const scrollToElement = () => {
        const sectionElement = document.getElementById('stationLocatorFeature');
        sectionElement.scrollIntoView({behavior: 'smooth'})
    }

    const toggleSignIn = () => {
        if (isMobile || isSmallTablet) {
            dispatch(toggleMobileLogin())
        } else {
            dispatch(toggleLoginModal())
        }
    }

    return (
        <Portal id="react-portal-stationLocator">
            <section className="gb--grid gb--grid-locator">
                <CardIconCentered
                    type="button"
                    Icon={TravelingDotComIconGlobe}
                    title={locatorCardTitle}
                    description={locatorCardDescription}
                    onClick={scrollToElement}
                    cardProps={{
                        className: "card-icon-centered__clickable_vertical",
                    }}
                />
                <CardIconCentered
                    type="button"
                    Icon={IconTicketQr}
                    title={purchasedTicketCardTitle}
                    description={purchasedTicketCardDescription}
                    onClick={toggleSignIn}
                    cardProps={{
                        className: "card-icon-centered__clickable_vertical",
                    }}
                />
            </section>
            <StationLocatorInputForm/>
        </Portal>
    );
}

export default StationLocator;